export const RequirementType = {
  mandatory: 0,
  optional: 1,
  optionalInGroup: 2,
};
